import { render, staticRenderFns } from "./CampoAdicionalOpcoes.vue?vue&type=template&id=38d459b5&scoped=true"
import script from "./CampoAdicionalOpcoes.vue?vue&type=script&lang=js"
export * from "./CampoAdicionalOpcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d459b5",
  null
  
)

export default component.exports